import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationCheckedPluginService } from './checked.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';

@Component({
    selector: 'installation-checked-edit',
    templateUrl: './checked-edit.component.html',
    standalone: false
})
export class InstallationCheckedEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public statuses: any[];
  public currentItem: any;

  private checkedValueToRemove: number;
  private sub = new Subscription();

  @ViewChild('statusesModal', { static: true }) statusesModal: ModalComponent;
  @ViewChild('checkedValueDeleteConfirm', { static: true }) checkedValueDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected cdRef: ChangeDetectorRef,
    location: Location,
    protected pluginService: InstallationCheckedPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['checkedValues'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateCheckedValues(this.inspectionId, this.pointId, this.pluginId, model.checkedValues)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['checkedValues'];
    control.push(this.initChecked());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['checkedValues'];
    control.removeAt(this.checkedValueToRemove);
  }

  public onClose(e: any) {
    this.currentItem.controls['Status'].markAsTouched();
  }

  public selectStatusesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Status'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Status'].setValue(selectedIndex);
  }

  public openStatusSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.statusesModal, this.statuses, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['checkedValues'];
    this.currentItem = control.controls[i];
  }

  public openCheckedValueDeleteConfirm(i: number) {
    this.checkedValueDeleteConfirm.open();
    this.checkedValueToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.statuses = _.orderBy(this.pluginService.getStatuses(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      checkedValues: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['checkedValues'];
    _.forEach(this.plugin.config.CheckedValues, (el) => {
      control.push(this.initChecked(el));
    });
  }

  private initChecked(el?: any) {
    return this.fb.group({
      Label: new UntypedFormControl(el?.Label ?? ''),
      Status: new UntypedFormControl(el && el.Status ? parseInt(el.Status) : 0),
      Comment: new UntypedFormControl(el?.Comment ?? '')
    });
  }
}
